export default {
  crops: [],
  filter: '',
  filterdCrops: [],
  cropGroups: []
}
